// extracted by mini-css-extract-plugin
module.exports = {"form":"UserForm_form__1HixU","inputGroup":"UserForm_inputGroup__3VOcp"};